module.exports = __webpack_public_path__ + "eec11e9a9405b51818fbe6713c0cb8b9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trompet_spelen.mp3
// module id = 108
// module chunks = 0